module.exports = __webpack_public_path__ + "static/img/day_report_win3.728a9b52.png";